export function durationFormatter(minutes?: number | null) {
  const maxEventDurationInMinutes = minutes ?? 0;
  const hours = Math.floor(maxEventDurationInMinutes / 60);
  const min = maxEventDurationInMinutes % 60;
  if (min === 0) return `${hours}h`;
  return `${hours}h ${min}m`;
}
